export enum FiatProvider {
  MOONPAY = 'moonpay',
}

export const FiatIcons: Record<FiatProvider, string> = {
  [FiatProvider.MOONPAY]: require(`@/assets/logos/moonpay-logo.png`),
};
